<template>
  <div class="header-item" @click="onClickItem">
    <span class="inline-flex items-center">
      <span class="w-full" v-html="label"></span>
    </span>
    <span class="chevron">
      <div v-if="sorted.index === index && sorted.order !== ''" class="chevron-container absolute">
        <i class="up" :class="{'active': sorted.order === 'asc'}"/>
        <i class="down" :class="{'active': sorted.order === 'desc'}"/>
      </div>
    </span>
  </div>
</template>

<script>
export default {
  name: "HeaderItem",
  props: {
    label: String,
    value: {
      type: Object,
      default: () => ({
        index: '',
        key: '',
        order: ''
      })
    },
    sortKey: String, // 클릭시 반환될 key
    index: Number, // 몇 번째 헤더인지
  },
  computed: {
    // 정렬 순서를 저장하는 객체
    sorted: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {

    // 헤더 클릭시 정렬 순서를 변경, 부모 컴포넌트에게 이벤트 전달
    onClickItem() {
      if (this.sortKey === 'no') {
        return;
      }
      const _order = ['', 'asc', 'desc']
      const sorted = Object.assign({}, this.sorted)
      sorted.index = this.index;
      sorted.key = this.sortKey;
      sorted.order = this.sorted.index === this.index ? _order[(_order.indexOf(this.sorted.order) + 1) % 3] : 'asc'
      this.sorted = sorted
      this.$emit('click', this.sorted)
    }
  }
}
</script>

<style lang="scss" scoped>
.header-item {
  display: grid;
  grid-template-columns: 1fr auto;
  cursor: pointer;
  padding: 10px 15px;

  -webkit-user-select:none;
  -moz-user-select:none;
  -ms-user-select:none;
  user-select:none
}
.chevron {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  .chevron-container {
    display: grid;
    gap: 4px;
  }
  i.up {
    width: 0;
    height: 0;
    border-bottom: 5px solid #D2D2D2;
    border-top: 5px solid transparent;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;

    &.active {
      border-bottom: 5px solid #6670CB;
    }
  }
  i.down {
    width: 0;
    height: 0;
    border-bottom: 5px solid transparent;
    border-top: 5px solid #D2D2D2;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;

    &.active {
      border-top: 5px solid #6670CB;
    }
  }
}
</style>
